import { BoardTypes } from './board-types.enum';

export const factors: Record<BoardTypes, number> = {
  [BoardTypes.PLAYER_BOARD]: 2,
  [BoardTypes.PAIR_PLAYER_BOARD]: 11,
  [BoardTypes.TIE]: 8,
  [BoardTypes.BANKER_BOARD]: 1.95,
  [BoardTypes.PAIR_BANKER_BOARD]: 11,
};
